import { rgba } from 'polished';

const ANIMATED_OVERLAY_THEME_KEY="animatedOverlay";const modifyAnimatedOverlayTheme=a=>{const{colors:{white:b}}=a;return {...a,[ANIMATED_OVERLAY_THEME_KEY]:{fixedWrapper:{backgroundColor:rgba(b,.75)}}}};

export { ANIMATED_OVERLAY_THEME_KEY, modifyAnimatedOverlayTheme as default };
